import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingBindingPath  {
    _originalTypeClassName = "zERP.BO.AccountingBindingPath";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingBindingPath.translate = translateService;
}
this.Display = null;
this.FullPath = null;
this.ClassName = null;
this._key = this.FullPath = ""; 
}

static translate: TranslateService;
_key: any;
Display:any;
private _FullPath:any;
get FullPath(): any {
    return this._FullPath;
  }
set FullPath(value: any) {
    this._FullPath = value;
    this._key = value;
  }
ClassName:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.FullPath == null || $this.FullPath == "";
            }


}